import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-flex w-full items-center rounded-full border border-concrete-300 bg-white px-3 py-2 font-primary text-sm text-black focus:outline-none focus:ring-4 focus:ring-celestial-500 group-hover:bg-concrete-200 md:max-w-xs print:hidden" }
const _hoisted_2 = { class: "pr-2 font-bold" }

interface Props {
	label: string;
	values: string;
	type: string;
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterConsent',
  props: {
    label: {},
    values: {},
    type: {},
    utilities: { default: "" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.utilities)
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label) + ":", 1),
      _createTextVNode(" " + _toDisplayString(__props.values), 1)
    ])
  ], 2))
}
}

})